import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { BudgetResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

// budgets now follows the standard list pattern (search/pagination/sort)
type BudgetListResult = { hits: BudgetResult[]; total: number; page: number }

const BUDGET_FIELDS = `amount appointmentGoal channel id internalGoal leadGoal locationId mqlGoal patientGoal targetSpend yearMonth`

const LIST_QUERY = graphql(`
  query Budgets($search: String, $pagination: PaginationInput, $sort: SortInput) {
    budgets(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        amount
        appointmentGoal
        channel
        id
        internalGoal
        leadGoal
        locationId
        mqlGoal
        patientGoal
        targetSpend
        yearMonth
      }
      total
      page
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateBudgetStore($id: ID!, $input: UpdateBudgetInput!) {
    updateBudget(id: $id, input: $input) {
      amount
      appointmentGoal
      channel
      id
      internalGoal
      leadGoal
      locationId
      mqlGoal
      patientGoal
      targetSpend
      yearMonth
    }
  }
`)

export class BudgetStore extends EntityStore<BudgetResult, BudgetListResult, undefined, typeof UPDATE_MUTATION> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      updateMutation: UPDATE_MUTATION,
      extractList: (data: any) => data.budgets,
      extractMutated: (data: any) => data.updateBudget,
    })
  }
}
